/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import UseEditAdminForm from "../BackendV2/Admin/Parametre/request/UseEditAdminForm";
// import * as IconlyPack from 'react-iconly';

const CRUDAdminModal = ({ admin }) => {
  const {
    register,
    onSubmit,
    formState,
    isSuccessfullySubmitted,
    clearErrors,
    setValue,
  } = UseEditAdminForm();

  useEffect(() => {
    if (formState.errors) {
      setTimeout(() => {
        Object.entries(formState.errors).map(([key]) => {
          return clearErrors(key);
        });
      }, 3000);
    }
  }, [formState]);

  useEffect(() => {
    if (admin?.id) {
      setValue("prenom", admin?.prenom);
      setValue("nom", admin?.nom);
      setValue("adresse", admin?.adresse);
      setValue("email", admin?.email);
      setValue("phone", admin?.phone);
      setValue("id", admin?.id);
    }
  }, [admin]);
  return (
    <div className="modal-dialog easypm-modal-dialog modal-lg">
      <div className="modal-content easypm-modal-content">
        <div className="modal-header easypm-modal-header">
          <h5 className="modal-title easypm-modal-title" id="AddingFamilyModal">
            Modifier un admin
          </h5>
          <button
            type="button"
            className="close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body easypm-modal-body">
          <div className="add-family-form-container">
            <form className="crud-form" onSubmit={onSubmit}>
              <div className="row crud-row">
                <div className="col-md-6 crud-col-item">
                  <div className="form-group crud-form-group">
                    <label htmlFor="prenom">Prénom</label>
                    <input
                      type="text"
                      placeholder="Prénom"
                      name="prenom"
                      className="form-control crud-form-control"
                      id="prenom"
                      {...register("prenom")}
                    />
                    {formState?.errors && formState?.errors?.prenom && (
                      <div className="alert alert-danger epm-alert-danger closer m-t-10">
                        {formState?.errors?.prenom?.message}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6 crud-col-item">
                  <div className="form-group crud-form-group">
                    <label htmlFor="nom">Nom</label>
                    <input
                      type="text"
                      placeholder="Nom"
                      name="nom"
                      className="form-control crud-form-control"
                      id="nom"
                      {...register("nom")}
                    />
                    {formState?.errors && formState?.errors?.nom && (
                      <div className="alert alert-danger epm-alert-danger closer m-t-10">
                        {formState?.errors?.nom?.message}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6 crud-col-item">
                  <div className="form-group crud-form-group">
                    <label htmlFor="email">Email</label>
                    <input
                      type="email"
                      placeholder="Email"
                      name="email"
                      className="form-control crud-form-control"
                      id="email"
                      {...register("email")}
                    />
                    {formState?.errors && formState?.errors?.email && (
                      <div className="alert alert-danger epm-alert-danger closer m-t-10">
                        {formState?.errors?.email?.message}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6 crud-col-item">
                  <div className="form-group crud-form-group">
                    <label htmlFor="telephone">Téléphone</label>
                    <input
                      type="text"
                      placeholder="Téléphone"
                      name="phone"
                      className="form-control crud-form-control"
                      id="telephone"
                      {...register("phone")}
                    />
                    {formState?.errors && formState?.errors?.phone && (
                      <div className="alert alert-danger epm-alert-danger closer m-t-10">
                        {formState?.errors?.phone?.message}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6 offset-md-6 crud-form-action-btn-container">
                  <button
                    className="btn btn-default cancelleb-btn"
                    data-bs-dismiss="modal"
                  >
                    Retour
                  </button>
                  {isSuccessfullySubmitted && (
                    <button
                      className="btn btn-primary crud-submit-btn"
                      disabled
                    >
                      En cours &nbsp;
                      <i className="fas fa-spin fa-spinner"></i>
                    </button>
                  )}
                  {!isSuccessfullySubmitted && (
                    <button className="btn btn-primary crud-submit-btn">
                      Enregistrer
                    </button>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CRUDAdminModal;
